import { BillingAdjustment, Invoice, InvoiceLineItem, PaymentLineItem } from "../../../Utilities";
import * as ModelUtilities from "../_General";

export type PrecomputedInvoice = {
	status: ModelUtilities.PaymentStatus;
	totalAmount: number;
	totalPaid: number;
	amountDue: number;
};

export function precomputeInvoice(
	invoice: Pick<Invoice, "dueDate"> & {
		invoiceLineItems: Pick<InvoiceLineItem, "amount">[];
		paymentLineItems: Pick<PaymentLineItem, "amount">[];
		billingAdjustments: Pick<BillingAdjustment, "amount">[];
	},
): PrecomputedInvoice {
	const totalAmount = calculateTotalAmount(invoice);
	const totalPaid = calculateTotalPaid(invoice);
	const amountDue = Math.max(totalAmount - totalPaid, 0);
	const status = getPaymentStatusFromValues(amountDue, invoice.dueDate);
	return { status, totalAmount, totalPaid, amountDue };
}

export function getPaymentStatus(
	invoice: Pick<Invoice, "dueDate"> & {
		paymentLineItems: Pick<PaymentLineItem, "amount">[];
		billingAdjustments: Pick<BillingAdjustment, "amount">[];
	},
	invoiceAmount: number,
	amountPaid?: number,
) {
	amountPaid = amountPaid ?? calculateTotalPaid(invoice);
	const amountDue = Math.max(invoiceAmount - amountPaid, 0);
	return getPaymentStatusFromValues(amountDue, invoice.dueDate);
}

export function getPaymentStatusFromValues(amountDue: number, dueDate: Invoice["dueDate"]) {
	return ModelUtilities.getPaymentStatusFromValues(amountDue, dueDate);
}

export function calculateOutstandingBalance(invoice: {
	invoiceLineItems: Pick<InvoiceLineItem, "amount">[];
	paymentLineItems: Pick<PaymentLineItem, "amount">[];
	billingAdjustments: Pick<BillingAdjustment, "amount">[];
}) {
	const totalAmount = calculateTotalAmount(invoice);
	const totalPaid = calculateTotalPaid(invoice);
	return Math.max(totalAmount - totalPaid, 0);
}

export function calculateTotalAmount(invoice: { invoiceLineItems: Pick<InvoiceLineItem, "amount">[] }) {
	return invoice.invoiceLineItems.reduce((a, e) => a + e.amount, 0);
}

export function calculateTotalPaid(invoice: {
	paymentLineItems: Pick<PaymentLineItem, "amount">[];
	billingAdjustments: Pick<BillingAdjustment, "amount">[];
}) {
	// TODO refunds handling

	let total = 0;
	for (let i = 0; i < invoice.paymentLineItems.length; i++) {
		total += invoice.paymentLineItems[i].amount;
	}
	for (let i = 0; i < invoice.billingAdjustments.length; i++) {
		total += invoice.billingAdjustments[i].amount;
	}
	return total;
}
